"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.OrderLatenessStatus=void 0;var t;(function(e){e.Estimated="ESTIMATED",e.Late="LATE",e.Missing="MISSING",e.OnTime="ON_TIME"})(t||(exports.OrderLatenessStatus=t={}));
//# sourceMappingURL=OrderLatenessStatus.js.map
